"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const constants_1 = require("../constants");
const ListItem = ({ item }) => (react_1.default.createElement(react_core_1.DescriptionListGroup, null,
    react_1.default.createElement(react_core_1.DescriptionListTerm, null, item.key),
    react_1.default.createElement(react_core_1.DescriptionListDescription, null, item.value || constants_1.DASH)));
const ClusterPropertiesList = ({ leftItems, rightItems = [] }) => {
    return (react_1.default.createElement(react_core_1.Grid, { hasGutter: true },
        react_1.default.createElement(react_core_1.GridItem, { span: rightItems.length ? 6 : 12 },
            react_1.default.createElement(react_core_1.DescriptionList, null, leftItems.map((item) => (react_1.default.createElement(ListItem, { key: item.key, item: item }))))),
        rightItems.length && (react_1.default.createElement(react_core_1.GridItem, { span: 6 },
            react_1.default.createElement(react_core_1.DescriptionList, null, rightItems.map((item) => (react_1.default.createElement(ListItem, { key: item.key, item: item }))))))));
};
exports.default = ClusterPropertiesList;
//# sourceMappingURL=ClusterPropertiesList.js.map